import { Component,Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-interval',
  templateUrl: './interval.component.html',
  styleUrls: ['./interval.component.scss']
})
export class IntervalComponent {

  @Input() physicalExamOptions :any;
  @Input() physicalExamOptionsResponse :any;
  @Input() currentCaseDay: number = 1;
  @Input() currentCaseTime: string = '00:00';
  @Output() timeAdvance = new EventEmitter<{days: number, hours: number, minutes: number}>();
  
  totalMinutes=0;
  futureTime: string = '';
  // physicalExamOptions = [
  //   'General Appearance',
  //   'Skin',
  //   'Breasts',
  //   'Lymph Nodes',
  //   'HEENT/Neck',
  //   'Chest/Lungs',
  //   'Heart/Cardiovascular',
  //   'Abdomen',
  //   'Genitalia',
  //   'Rectal',
  //   'Extremities/Spine',
  //   'Neuro/Psych'
  // ];

  selectedOptions=[];
  intervalFollowUp: boolean = false;
  showConfirmation=false;
  selectedIds: number[] = [];
  showPhysicalExamination=false;

  onOkClick(): void {
    
    // Handle OK button click
    // console.log('Selected options:', this.selectedOptions);
    // console.log('Interval/Follow up:', this.intervalFollowUp);
console.log(this.physicalExamOptionsResponse)
    this.selectedOptions = []
    this.totalMinutes = 0
    //get the details of the selected examinations
    for (let i=0;i<this.selectedIds.length;i++)
    {
      // iterate over the physicalExamOptions and get the details of the selected examinations
      for (let j=0;j<this.physicalExamOptionsResponse.length;j++)
      {
        if (this.physicalExamOptionsResponse[j].evaluationId==this.selectedIds[i])
        {
          this.selectedOptions.push(this.physicalExamOptionsResponse[j])
          this.totalMinutes += parseInt(this.physicalExamOptionsResponse[j].duration)
        }
      }
    }
    console.log(this.selectedOptions)

    // Calculate future time
    this.calculateFutureTime();

    this.showConfirmation=true;
  }

  calculateFutureTime(): void {
    // Parse current time
    const [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    
    // Add total minutes to current time
    let totalMinutesFromStart = (currentHours * 60) + currentMinutes + this.totalMinutes;
    
    // Calculate new day, hours, and minutes
    let newDay = this.currentCaseDay;
    let newHours = Math.floor(totalMinutesFromStart / 60);
    let newMinutes = totalMinutesFromStart % 60;
    
    // Handle day overflow
    while (newHours >= 24) {
      newDay++;
      newHours -= 24;
    }
    
    // Format the future time string
    const formattedHours = newHours.toString().padStart(2, '0');
    const formattedMinutes = newMinutes.toString().padStart(2, '0');
    this.futureTime = `Day ${newDay} @ ${formattedHours}:${formattedMinutes}`;
  }

  selectValue(event)

  {
    console.log(event)
  }

  onClearClick(): void {
    // Clear all selections
    this.selectedIds =[]
    this.intervalFollowUp = false;
  }
  showDetails()
  {
    //show the physical examination here 
    this.showConfirmation=false;
    this.showPhysicalExamination =true;

    // Don't emit time advance here - wait until examination is closed
  }
  

onCheckboxChange(id: number, event: Event): void {
  const isChecked = (event.target as HTMLInputElement).checked;

  if (isChecked) {
    if (!this.selectedIds.includes(id)) {
      this.selectedIds.push(id);
    }
  } else {
    this.selectedIds = this.selectedIds.filter(selectedId => selectedId !== id);
  }
  console.log(this.selectedIds)
}

closeExamination()
{
  this.showPhysicalExamination=false;
  
  // Emit time advance event when examination is closed
  const [futureHours, futureMinutes] = this.futureTime.split('@')[1].trim().split(':').map(Number);
  const futureDay = parseInt(this.futureTime.split('Day')[1].split('@')[0].trim());
  
  this.timeAdvance.emit({
    days: futureDay,
    hours: futureHours,
    minutes: futureMinutes
  });
  
  this.selectedIds=[];
}
} 